import Vue from 'vue';
import Router from 'vue-router';

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location, onResolve, onReject) {
//   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
//   return originalPush.call(this, location).catch(err => err)
// }

import Login from '@/components/Login';
import FieldHospitalRegister from '@/components/Covid/RegisterEDSUser';
import FieldHome from '@/components/Covid/Home';
import ViewBulletins from '@/components/Covid/ViewBulletins';
import CovidCapacity from '@/components/Covid/VaccineCapacity';
import CovidAllocation from '@/components/Covid/VaccineAllocation';
import ManageRequests from '@/components/DPEBB/Ministry/ManageRequests';
import ManageAllocations from '@/components/DPEBB/Ministry/ManageAllocations'; 
import Bulletins from '@/components/DPEBB/Ministry/Bulletins';

//import Notifications from '@/components/Covid/dynamicExample';
import Notifications from '@/components/Covid/Notifications';

//faq
import DpebbFaq from '@/Common/Default/Faq';
//contact us
import DpebbContactus from '@/Common/Default/ContactUs';

//HelpDesk @/components/DPEBB/Administrator/UserPassword.vue  @/DPEBB/HelpDesk/ManageUserPassword
import HelpDeskManagePassword from '@/components/DPEBB/Administrator/UserPassword.vue';
import UpdatePasswordHome from '@/components/DPEBB/Administrator/UserUpdatePassowrd' ;

//import SuperUserManageClinics from '@/DPEBB/SuperUser/ManageClinics';
// import SuperUserManageBulletins from '@/DPEBB/SuperUser/ManageBulletins';
// import SuperUserManagerUser from '@/DPEBB/SuperUser/ManageUser';
// import SuperUserManagerRolePer from '@/DPEBB/SuperUser/ManageRolePermissions';
// import SuperUserManagePassword from '@/DPEBB/SuperUser/ManageUserPassword';
// import SuperUserManageUserRoles from '@/DPEBB/SuperUser/ManageUserRoles';

// import AdminUserManageClinics from '@/DPEBB/Administrator/ManageClinics';
// import AdminUserManageBulletins from '@/DPEBB/Administrator/ManageBulletins';
// import AdminManagerUser from '@/DPEBB/Administrator/ManageUser';
// import AdminManagerRolePer from '@/DPEBB/Administrator/ManageRolePermissions';
// import AdminUserManageUserRoles from '@/DPEBB/Administrator/ManageUserRoles';
import DPEBBHome from '@/components/DPEBB/Home';
import { store } from '../Store/store';
// function patchRouterMethod (Router, methodName)
// {
//   Router['old' + methodName] = Router[methodName]
//   Router[methodName] = async function (location)
//     {
//         return Router['old' + methodName](location).catch((error) =>
//         {
//             if (error.name === 'NavigationDuplicated')
//             {
//                 return this.currentRoute
//             }
//             throw error
//         })
//     }
// }
// patchRouterMethod(Router, 'push')
// patchRouterMethod(Router, 'replace')
Vue.use(Router);
export default new Router( {mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'Login',
    //   component: Login
    // },
    {
      name: 'home',
      path: '/',
      components: { default: Login}
    },
    {
      name: 'DPEBBHome',
      //path: '/DPEBB/MainHome', // to open a path to Admin uncomment this and comment the line below 
      path : '/DPEBB/Home',
      components: { default: DPEBBHome}
    },
    // {
    //   name: 'FhGuide',
    //   path: '/Docs/FHUserGuide',
    //   components: { default: FhUserguide}
    // },
      //Field Hospital
      {
        name: 'FieldDash',
        path: '/CovidVac/Home',
        components: { default: FieldHome},
      },
       //Field Hospital
       {
        name: 'FHRegistration',
        path: '/Covid/CovidProvider/RegisterEDSUser',
        components: { default: FieldHospitalRegister},
      },
      {
        name: 'VaccineCapacity',
        path: '/Covid/CovidProvider/VaccineCapacity',
        components: { default: CovidCapacity},
      },
      {
        name: 'VaccineAllocation',
        path: '/Covid/CovidProvider/VaccineAllocation',
        components: { default: CovidAllocation},
      },
      {
        name: 'ViewBulletins',
        path: '/Covid/CovidProvider/ViewBulletins',
        components: { default: ViewBulletins},
      },
      {
        name: 'Notifications',
        path: '/Covid/CovidProvider/Notifications',
        components: { default: Notifications},
      },
      {
        name: 'Bulletins',
        path: '/DPEBB/Ministry/ManageBulletins',
        components: { default: Bulletins},
      },
      {
        name: 'ManageRequest',
        path: '/DPEBB/Ministry/ManageRequests',
        components: { default: ManageRequests},
      },
      {
        name: 'ManageAllocation',
        path: '/DPEBB/Ministry/ManageAllocations',
        components: { default: ManageAllocations},
      },
      //  DpebbFaq DpebbContactus
      {
        name: 'DpebbFaq',
        path: '/DPEBB/Faq',
        components: { default: DpebbFaq}
      },
      {
        name: 'DpebbContactus',
        path: '/DPEBB/Contactus',
        components: { default: DpebbContactus}
      },

    {
      name: 'UpdatePassword',
      path: '/UpdatePassword',
      components: { default: UpdatePasswordHome},
    },
  //  {
  //     name:'SuperUserManageClinics',
  //     path: '/DPEBB/SuperUser/ManageClinics',
  //     components:{default: SuperUserManageClinics}
  //   },
  //   {
  //     name:'SuperUserManageBulletins',
  //     path:'/DPEBB/SuperUser/ManageBulletins',
  //     components:{default:SuperUserManageBulletins}
  //   },
  //   {
  //     name: 'SuperUserManagerUser',
  //     path: '/DPEBB/SuperUser/ManageUser',
  //     components: { default: SuperUserManagerUser}
  //   },
  //   {
  //     name: 'SuperUserManagerRolePer',
  //     path: '/DPEBB/SuperUser/ManageRolePermissions',
  //     components: { default: SuperUserManagerRolePer}
  //   },
  //   {
  //     name: 'SuperUserManageUserPassword',
  //     path: '/DPEBB/SuperUser/ManageUserPassword',
  //     components: { default: SuperUserManagePassword}
  //   },
  //   {
  //     name: 'SuperUserManageUserRoles',
  //     path: '/DPEBB/SuperUser/ManageUserRoles',
  //     components: {default:SuperUserManageUserRoles}
  //   },
  //   {
  //     name:'AdminUserManageClinics',
  //     path: '/DPEBB/Administrator/ManageClinics',
  //     components:{default: AdminUserManageClinics}
  //   },
  //   {
  //     name:'AdminUserManageBulletins',
  //     path:'/DPEBB/Administrator/ManageBulletins',
  //     components:{default:AdminUserManageBulletins}
  //   },
  //   {
  //     name: 'AdminManagerUser',
  //     path: '/DPEBB/Administrator/ManageUser',
  //     components: { default: AdminManagerUser}
  //   },
  //   {
  //     name: 'AdminManagerRolePer',
  //     path: '/DPEBB/Administrator/ManageRolePermissions',
  //     components: { default: AdminManagerRolePer}
  //   },
  //   {
  //     name: 'AdminUserManageUserRoles',
  //     path: '/DPEBB/Administrator/ManageUserRoles',
  //     components: {default:AdminUserManageUserRoles}
  //   },
  //   //HelpDesk
    {
      name: 'HelpDeskManagePassword',
      path: '/DPEBB/HelpDesk/ManageUserPassword',
      components: { default: HelpDeskManagePassword},
    },
    {
      path: '*',
      name: 'all',
      component: Login
    }
  ]

});
